import React from 'react';
import {Loader} from 'semantic-ui-react'
import contents from "../utils/content";
const content = contents()
const Loading = () => <Loader active inline='centered' style={{marginTop: 150}}>{content.loading}...</Loader>;

export default Loading;